<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/view', params: {id: branchClass.pattern.branchProgram.branchID} }">
                                {{ branchClass.pattern.branchProgram.branch.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleModified()" v-bind:to="{ name: 'branch/program/edit', params: {id: branchClass.pattern.branchProgram.branchID, programID: branchClass.pattern.branchProgramID} }">
                                {{ branchClass.pattern.branchProgram.grade.name }} - {{ branchClass.pattern.branchProgram.programType.name }}
                            </router-link>
                            <router-link v-else v-bind:to="{ name: 'branch/view', params: {id: branchClass.pattern.branchProgram.branchID} }">
                                {{ branchClass.pattern.branchProgram.grade.name }} - {{ branchClass.pattern.branchProgram.programType.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/program/pattern/view', params: {id: branchClass.pattern.branchProgram.branchID, programID: branchClass.pattern.branchProgramID, patternID: branchClass.patternID} }">
                                Kelas
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ branchClass.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mt-2">
                <h4 class="text-danger font-weight-bold mb-3">Kelas</h4>
                <div class="row">
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Cabang</h4>
                        <p class="font-weight-bold mb-0">{{ branchClass.pattern.branchProgram.branch.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ branchClass.pattern.branchProgram.grade.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Tipe Program</h4>
                        <p class="font-weight-bold mb-0">{{ branchClass.pattern.branchProgram.programType.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <div class="row">
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Hari Pola</h4>
                                <p class="font-weight-bold mb-0" v-for="period in branchClass.pattern.periods" v-bind:key="period.id">
                                    {{ $moment.weekdays(period.day) }}
                                </p>
                            </div>
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Sesi Pola</h4>
                                <p class="font-weight-bold mb-0" v-for="period in branchClass.pattern.periods" v-bind:key="period.id">
                                    {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Nama Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ branchClass.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kapasitas</h4>
                        <p class="font-weight-bold mb-0" v-for="(capacityAttribute, index) in capacityAttributes">Semester {{ index + 1 }}: {{ branchClass[capacityAttribute] }}/{{ branchClass.capacity }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Semester</h4>
                        <select v-model="form.semester" class="form-control form-control-sm" required v-on:change="paginate(1)">
                            <option v-for="(capacityAttribute, index) in capacityAttributes" v-bind:value="index + 1" v-bind:key="index + 1">Semester {{ index + 1 }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col" name="identity" v-on:click="sort">
                                    No. Peserta <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" name="name" v-on:click="sort">
                                    Nama Lengkap <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" name="schoolID" v-on:click="sort">
                                    Asal Sekolah <i class="fa fa-chevron-down"></i>
                                </th> 
				<template v-if="branchClass.pattern.branchProgram.branch.id == 11">
                                <template v-if="roleElligibleView()">
                                    <th scope="col" v-for="profileLabel in profileLabels" v-bind:name="profileLabel" v-on:click="sort">
                                        {{ humanize(profileLabel) }} <i class="fa fa-chevron-down"></i>
                                    </th>
                                </template>
				</template>
				<template v-for="tryout in tryouts">
                                <template v-if="tryout.maxScore" >
				<th scope="col" >
                                    
				    <p class="mb-0" v-if="tryout.group">({{ tryout.group }})</p>
                                    {{ tryout.name }}
				    
                                </th>
				</template>
				</template>
                                <th scope="col" v-if="roleElligiblePartialView() || roleElligibleView()">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                <td>
                                    <span class="text-loading">{{ student.identity }}</span>
                                </td>
                                <td>
                                    <span class="text-loading" v-if="student.user">{{ student.user.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading" v-if="student.school">{{ student.school.name }}</span>
                                </td>
				<template v-if="branchClass.pattern.branchProgram.branch.id == 11">
                                <template v-if="roleElligibleView()">
                                    <td v-for="profileLabel in profileLabels">
                                        <span v-bind:class="{'text-loading': typeof student.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(student.additionals[profileLabel]) }}</span>
                                    </td>
                                </template>
                                </template>
                                <template v-for="(tryout, index) in tryouts" >
				<template v-if="tryout.maxScore" >
					<td >
                                    
                                        	{{ student.tryouts[index].score }}<template v-if="tryout.group"></template>
                                    
                                    
                                	</td>
				</template>	
				</template>
                                <td v-if="roleElligiblePartialView()">
                                    <router-link v-bind:to="{name: 'student/score', params: {id: student.userID}}" class="text-loading">
                                        Laporan Nilai
                                    </router-link>
                                </td>
                                <td v-else-if="roleElligibleView()">
                                    <router-link v-bind:to="{name: 'student/view', params: {id: student.userID}}" class="text-loading">
                                        Detail
                                    </router-link>
                                </td>
                            </tr>
                            <template v-if="tryouts.length">
                                <tr>
                                    <td class="bg-transparent"></td>
                                    <td class="font-weight-medium text-right bg-transparent" v-bind:colspan="2 + (roleElligibleView() ? profileLabels.length : 0)">
                                        Rata-rata
                                    </td>
                                    <template v-for="(tryout, index) in tryouts">
                                    <template v-if="tryout.avgScore">
				    <td >

                                            {{ tryout.avgScore }}<template v-if="tryout.group"></template>
                                        
                                    </td>
                                    </template>
				    </template>
                                    <td class="bg-transparent" v-if="roleElligiblePartialView() || roleElligibleView()"></td>
                                </tr>
                                <tr>
                                    <td class="bg-transparent"></td>
                                    <td class="font-weight-medium text-right bg-transparent" v-bind:colspan="2 + (roleElligibleView() ? profileLabels.length : 0)">
                                        Nilai Tertinggi
                                    </td>
                                    <template v-for="(tryout, index) in tryouts" >
				    <template v-if="tryout.maxScore" >
				    <td >
                                        
                                            {{ tryout.maxScore }}<template v-if="tryout.group"></template>
                                        
                                        
                                    </td>
				    </template>
				    </template>
                                    <td class="bg-transparent" v-if="roleElligiblePartialView() || roleElligibleView()"></td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import { dragscroll } from 'vue-dragscroll';
    import { mapState } from 'vuex';

    export default {
        name: "BranchProgramPatternClassView",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile',
	    'term'
        ]),
	watch: {
            term() {
                this.paginate(this.page);
            }
        },
        data() {
            return {
                form: {
                    sortColumn: 'name',
                    sortType: 'asc',
                    semester: 1

                },
                tryouts: {},
                branchClass: {pattern: {branchProgram: {branch: {}, grade: {}, programType: {}}}},
                students: [
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []},
                    {user: {}, school: {}, additionals: {}, tryouts: []}
                ],
                pageCount: 0,
                page: 1,
                profileLabels: ['nomor_hp_siswa', 'nomor_hp_ayah', 'nomor_hp_ibu'],
                capacityAttributes: ['currentCapacity', 'secondCurrentCapacity', 'thirdCurrentCapacity', 'fourthCurrentCapacity']
            };
        },
        methods: {
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/branch-class/' + this.branchClass.id + '/list-student', {params: Object.assign({}, this.form, {page: page})}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            sort(event) {
                var column = event.currentTarget;
                var columnName = column.getAttribute("name");
                if (columnName) {
                    this.form.sortType = (this.form.sortColumn !== columnName || this.form.sortType !== 'asc') ? 'asc' : 'desc';
                    this.form.sortColumn = columnName;

                    document.querySelectorAll("table tr th[sort]").forEach(element => {
                        element.removeAttribute("sort");
                    });
                    column.setAttribute("sort", this.form.sortType);
                }
                this.paginate(1);
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            renderCheckBlank(value) {
                return (value !== '' && value !== null) || typeof value === typeof undefined ? value : " ";
            },
            roleElligibleModified() {
                return this.profile.isAdmin;
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchHead || this.profile.employee.isBranchStaff || this.profile.employee.isMentor ));
            },
            roleElligiblePartialView() {
                return this.profile.isEmployee && (this.profile.employee.isMentor || this.profile.employee.isTeacher);
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/branch-class/' + this.$route.params.classID).then(response => {
                this.branchClass = response.data.data;
                this.tryouts = this.branchClass.tryouts;
                this.paginate(1, false);

                document.title = this.branchClass.name + ' - ' + process.env.APP_NAME;
            });
        }
    };
</script>
<style scoped>
    @media (min-width: 768px) {
        .table-responsive .table td:first-child, .table-responsive .table th:first-child { min-width: 8.2rem;}
        .table-responsive .table td:nth-child(2), .table-responsive .table th:nth-child(2) { left: 8.2rem; top: auto; position: -webkit-sticky; position: sticky; }
    }
</style>


// WEBPACK FOOTER //
// src/components/branch/program/pattern/class/View.vue